const logIn = `
query login($tenantId: String!, $clientId: String!, $username: String!, $password: String!){
  token: token_2(tenantId: $tenantId, clientId: $clientId, username: $username, password: $password) {
    accessToken
    expiresIn
    error
  }
}
`

const me = `
query me{
  me{
    associatedUser{
      name
    }
    email
    targettedPermissions{
      permission{ id }
      targetIds
    }
  }
}
`

const readRoles = `
query readRoles{
  permissionGroups{
    id
    name
    description
  }
}`

const passwordValidators = `
query passwordValidators($tenantId: String!, $clientId: String) {
  passwordValidators(tenantId: $tenantId, clientId: $clientId) {
    requireConfirmPhoneNumber
    requireConfirmedEmail
    requireDigit
    requireLength
    requireLowercase
    requireUppercase
    requireNonAlphanumeric
    requireUniqueChars
  }
}`

const newPassword = `
mutation newPassword($tenantId: String!, $loginId: String!, $code: String!, $password: String!){
  resetPassword(tenantId: $tenantId, loginId: $loginId, code: $code, password: $password){
    status
    errors
  }
}
`

const forgotPassword = `
mutation forgotPassword($tenantId: String!, $forgotPasswordInput: forgotPasswordInput! ){
  forgotPassword(tenantId: $tenantId, forgotPasswordInput: $forgotPasswordInput){
    status
    errors
  }
}
`

const changePassword = `
mutation changePassword($changePasswordInput: changePasswordInput!){
  changePassword(changePasswordInput: $changePasswordInput){
    errors
    status
  }
}
`

const query = {
	logIn,
	me,
	readRoles,
	passwordValidators
}

const mutation = {
	newPassword,
	forgotPassword,
	changePassword
}

export { query, mutation }
